import { request } from "@umijs/max";

export const apiDocumentList = (params: any) => request(`document/list`, { params });

export const apiDocumentTypeOptions = () => request(`document/type/options`);

export const apiDocumentAdd = (data: any) => request(`document/add`, { 
    method: 'POST',
    data
});

export const apiDocumentUpdate = (data: any) => request(`document/update`, { 
    method: 'POST',
    data
});

export const apiDocumentDetail = (id: string) => request(`document/${id}`);

export const apiDocumentCategoryOptions = () => request(`document/category/options`);

export const apiDocumentPriorityOptions = () => request(`document/priority-options`);

export const apiDocumentFiles = (id: string) => request(`document/files/${id}`);

export const apiTypePieDataChart = () => request(`document/type/pie`);

export const apiActivityDataChart = (params: any) => request(`document/column-chart`, { params });

export const apiDocumentUpload = (data: any) => request(`document/file/upload`, {
    method: 'POST',
    data
})

export const apiDocumentDelete = (id: string) => request(`document/delete/${id}`, {
    method: 'POST'
});

export const apiDocumentFileDelete = (id: string) => request(`document/file/delete/${id}`, {
    method: 'POST'
})

export const apiDocumentSearch = (params: any) => request(`search`, { params });

export const apiDocumentTypes = () => request(`type/list`);

export const apiDocumentLogs = (params: any) => request(`document/logs`, { params });